import { Button, Dialog, FormGroup, HTMLSelect, InputGroup, Intent } from '@blueprintjs/core';
import { getKryBase } from 'app/utils/api';
import React, { useState } from 'react';
import ReactTable from 'react-table';
import * as superagent from 'superagent';

export const TextGame = (props: any) => {

    const [showingActions, setShowingActions] = useState(false);
    const [hasStartedGame, setHasStartedGame] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [lastState, setLastState] = useState("");
    const [expandedKeys, setExpandedKeys] = useState<Set<string>>(new Set());
    const [params, setParams] = useState({
        GAME_ID: '1',
        ROUND_ID: '1',
        TEMPLATE: 'TEMPLATE',
        ACTION_STRING: '0,0,0,0',
        SCENARIO_NAME: 'scenario_1',
        ROUND: '1',
        FIRST: '1'
    });

    const handleClick = async (template: string) => {
        setIsRunning(true);

        try {
            superagent.
                get(getKryBase(props.user) + 'kry?scenario=' + params.SCENARIO_NAME + "&uid=" + props.user.id + "&metadata=" + "game-debugger" + "&isToCreateGame=true").
                end((error: any, response: any) => {
                    setLastState(response.body);

                    setParams(prevParams => ({
                        ...prevParams,
                        GAME_ID: response.body['game-id']
                    }));

                    setIsRunning(false);
                    setHasStartedGame(true);
                });

        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleNextClick = async (template: string) => {
        try {
            setParams(prevParams => ({
                ...prevParams,
                ROUND: (parseInt(prevParams.ROUND) + 1).toString(),
                ROUND_ID: (parseInt(prevParams.ROUND_ID) + 1).toString(),
                FIRST: '0'
            })
            )

            setIsRunning(true);
            superagent.
                get(getKryBase(props.user) + params.GAME_ID + '/do/round/single?round=' + (parseInt(params.ROUND_ID)).toString() + "&scenarioName=" + params.SCENARIO_NAME + '&action=' + params.ACTION_STRING + "&gameID=" + params.GAME_ID).
                end((error: any, response: any) => {
                    setLastState(response.body);
                    setParams(prevParams => ({
                        ...prevParams,
                        ACTION_STRING: '0,0,0,0'
                    }));
                    setIsRunning(false);
                });
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const renderOutput = () => {

        return <div>
            {renderPlayingCharacter(lastState)}
            {renderIdeasTable()}
            {renderCharacterTable()}
            {renderStatementsTable(lastState)}
            {renderBucketsTable(lastState)}
            <div style={{ flex: '1', padding: '5px', backgroundColor: 'rgba(255,255,255,0.3)', minHeight: '80vh', width: '100%', height: '100%' }}>
                {renderJson(lastState)}
            </div>
        </div>
    }

    const toggleExpand = (key: string) => {
        setExpandedKeys(prev => {
            const newSet = new Set(prev);
            if (newSet.has(key)) {
                newSet.delete(key);
            } else {
                newSet.add(key);
            }
            return newSet;
        });
    };

    const renderAudio = (audio: string) => {
        const allAudios = audio.split(',');

        let audioPlayers = []

        for (let i = 0; i < allAudios.length; i++) {

            let cleaned = allAudios[i].toLocaleLowerCase();

            if (cleaned.includes("corey_") && cleaned.includes("mcorey_") === false) {
                cleaned = cleaned.replace("corey_", "mcorey_");
            }

            if (i === 0) {
                audioPlayers.push(<audio src={`https://dt7kar5non0r5.cloudfront.net/Simulation/business/${cleaned}`} autoPlay controls />)
            }
            else {
                audioPlayers.push(<audio src={`https://dt7kar5non0r5.cloudfront.net/Simulation/business/${cleaned}`} controls />)
            }
        }


        return <span>
            {audioPlayers}
        </span>
    }

    const renderPlayingCharacter = (data: any) => {
        try {
            let characterKeys = Object.keys(data.characters);

            let allCharacterDisplays = '';

            let audio = '';

            for (let i = 0; i < characterKeys.length; i++) {
                if (data.characters[characterKeys[i]]['focal'] === "true" || data.characters[characterKeys[i]]['focal'] === "True") {
                    allCharacterDisplays += characterKeys[i] + ': ' + JSON.stringify(data.characters[characterKeys[i]].display) + '\n';
                    if (data.characters[characterKeys[i]].display && data.characters[characterKeys[i]].display.audio) {
                        audio = data.characters[characterKeys[i]].display.audio;
                    }
                }
            }

            return <div>{allCharacterDisplays}
                {renderAudio(audio)}
            </div>
        }
        catch (e) {
            return <div>No characters found</div>
        }
    }

    const renderJson = (data: any, parentKey: string = '') => {
        if (typeof data === 'object' && data !== null) {
            return (
                <div>
                    <div className="ml-4">
                        {Object.keys(data).map(key => {
                            const fullKey = parentKey ? `${parentKey}.${key}` : key;
                            const isExpanded = expandedKeys.has(fullKey);
                            return (
                                <div key={fullKey}>
                                    <div
                                        className="cursor-pointer text-blue-500"
                                        onClick={() => toggleExpand(fullKey)}
                                    >
                                        {isExpanded ? '-' : '+'} {key}
                                    </div>
                                    {isExpanded && (
                                        <div className="ml-4">
                                            {renderJson(data[key], fullKey)}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        } else {
            return <div className="ml-4">{String(data)}</div>;
        }
    };
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setParams(prevParams => ({
            ...prevParams,
            [name]: value
        }));
    };

    const renderCharacterTable = () => {
        const columns = [
            {
                Header: "id",
                accessor: "id"
            },
            {
                Header: "name",
                accessor: "name"
            },
            {
                Header: "focal",
                accessor: "focal"
            },
            {
                Header: 'action',
                accessor: 'action',
                Cell: (props: any) => {
                    return JSON.stringify(props.value);
                }
            },
            {
                Header: 'tension',
                accessor: 'tension'
            }
        ];

        let ideas = [];

        try {
            const state = lastState;

            //@ts-ignore
            const ideasKeys = Object.keys(state.characters);

            for (let i = 0; i < ideasKeys.length; i++) {
                //@ts-ignore
                ideas.push(state.characters[ideasKeys[i]]);
            }
        }
        catch (e) { }

        return <div style={{ flex: '1', padding: '5px', backgroundColor: 'rgba(255,255,255,0.3)', width: '100%', height: '100%' }}>
            {ideas.length <= 0 ? <span></span> : <ReactTable data={ideas} pageSize={ideas.length} showPageSizeOptions={false} showPagination={false} sortable={false} columns={columns} />}
        </div>
    }

    const renderStatementsTable = (state) => {
        if (state.lastSeenStatements === undefined || state.lastSeenStatements === null) {
            return <span></span>
        }
        /*
            {
        "idea": 1,
        "scenario": "1",
        "statement-id": 1500,
        "type": "prem_neg",
        "bucket": 14,
        "text": "Is there something about your current place that's impacting your work focus because I'm just wondering if moving will make a big difference?",
        "audio_file": "mCorey_prem_neg_1500.mp3",
        "character": 1,
        "tag": "#Reason"
    },
    */
        const data = state.lastSeenStatements;

        const columns = [
            {
                Header: 'Statement ID',
                accessor: 'statement-id'
            },
            {
                Header: 'Type',
                accessor: 'type'
            },
            {
                Header: 'Text',
                accessor: 'text'
            },
            {
                Header: 'Audio',
                accessor: 'audio_file',
                Cell: (props) => {
                    return `https://dt7kar5non0r5.cloudfront.net/Simulation/business/${props.value ? props.value.toLowerCase() : ""}`
                }
            },
            {
                Header: 'Character',
                accessor: 'character'
            },
            {
                Header: "Idea",
                accessor: "idea"
            },
            {
                Header: 'Tag',
                accessor: 'tag'
            }
        ];

        return (
            data.length > 0 ?
            <ReactTable
                style={{ marginBottom: '10px'}}
                data={data}
                columns={columns}
                pageSize={data.length}
                showPageSizeOptions={false}
                showPagination={false}
                className="-striped -highlight"
            /> : <span></span>
        );
    }

    const renderBucketsTable = (state) => {
        const bucketNames = {
            "0": "EBUCKET_TYPE_INTRODUCE_IDEA_NEGATIVELY",
            "1": "EBUCKET_TYPE_INTRODUCE_IDEA_POSITIVELY",
            "2": "EBUCKET_TYPE_INTRODUCE_IDEA_NEUTRALLY",
            "3": "EBUCKET_TYPE_REINTRODUCE_IDEA_NEGATIVELY",
            "4": "EBUCKET_TYPE_REINTRODUCE_IDEA_POSITIVELY",
            "5": "EBUCKET_TYPE_REINTRODUCE_IDEA_NEUTRALLY",
            "6": "EBUCKET_TYPE_INTRODUCE_END_IDEA_NEGATIVELY",
            "7": "EBUCKET_TYPE_INTRODUCE_END_IDEA_POSITIVELY",
            "8": "EBUCKET_TYPE_INTRODUCE_END_IDEA_NEUTRALLY",
            "9": "EBUCKET_TYPE_WRAP_PLAN",
            "10": "EBUCKET_TYPE_WRAP_PREMISE",
            "11": "EBUCKET_TYPE_WRAP_END",
            "12": "EBUCKET_TYPE_STATE_NEGATIVELY_ON_PLAN",
            "13": "EBUCKET_TYPE_STATE_POSITIVELY_ON_PLAN",
            "14": "EBUCKET_TYPE_STATE_NEGATIVELY_ON_PREMISE",
            "15": "EBUCKET_TYPE_STATE_NEUTRALLY_ON_PREMISE",
            "16": "EBUCKET_TYPE_STATE_POSITIVELY_ON_PREMISE",
            "17": "EBUCKET_TYPE_STATE_NEGATIVELY_ABOUT_AN_ACTIVE_NPC",
            "18": "EBUCKET_TYPE_STATE_POSITIVELY_ABOUT_AN_ACTIVE_NPC",
            "19": "EBUCKET_TYPE_STATE_NEUTRALLY_ABOUT_AN_ACTIVE_NPC",
            "20": "EBUCKET_TYPE_STATE_NEGATIVELY_ABOUT_AN_PASSIVE_NPC",
            "21": "EBUCKET_TYPE_STATE_POSITIVELY_ABOUT_AN_PASSIVE_NPC",
            "22": "EBUCKET_TYPE_STATE_NEUTRALLY_ABOUT_AN_PASSIVE_NPC",
            "23": "EBUCKET_TYPE_MOVE_ON",
            "24": "EBUCKET_TYPE_TRANSITION"
        }

        if (state === undefined || state === null || state.lastSeenBucketValidity  === undefined || state.lastSeenBucketValidity  === null) {
            return <div></div>;
        }
        
        const data = state.lastSeenBucketValidity.map((bucket, index) => ({
            bucketName: bucketNames[index.toString()],
            isValid: bucket[3]
        }));

        const columns = [
            {
                Header: 'Bucket Name',
                accessor: 'bucketName'
            },
            {
                Header: 'Is Valid',
                accessor: 'isValid',
                Cell: (props) => {
                    if (props.value) {
                        return <span style={{ color: 'green' }}>True</span>
                    }
                    else {
                        return <span style={{ color: 'red' }}>False</span>
                    }
                }
            }
        ];

        return (
            <ReactTable
                data={data}
                columns={columns}
                defaultPageSize={data.length}
                showPageSizeOptions={false}
                className="-striped -highlight"
            />
        );
    }

    const renderIdeasTable = () => {
        const columns = [
            {
                Header: "id",
                accessor: "id"
            },
            {
                Header: "name",
                accessor: "name"
            },
            {
                Header: "work-done",
                accessor: "work-done"
            },
            {
                Header: 'mode',
                accessor: 'mode'
            }
        ];

        let ideas = [];

        try {
            const state = lastState;

            //@ts-ignore
            const ideasKeys = Object.keys(state.ideas);

            for (let i = 0; i < ideasKeys.length; i++) {
                //@ts-ignore
                ideas.push(state.ideas[ideasKeys[i]]);
            }
        }
        catch (e) { }

        return <div style={{ flex: '1', padding: '5px', backgroundColor: 'rgba(255,255,255,0.3)', width: '100%', height: '100%' }}>
            {ideas.length <= 0 ? <span></span> : <ReactTable data={ideas} pageSize={ideas.length} showPageSizeOptions={false} showPagination={false} sortable={false} columns={columns} />}
        </div>
    }

    const actionString = params.ACTION_STRING.split(',');

    const handleSelectChange = (index, value) => {
        const newActionString = [...actionString];
        if (index === 0 && value === "1") {
            newActionString[index] = value;
            newActionString[1] = '1';
            newActionString[2] = '1';
            newActionString[3] = '1';
            setParams(prevParams => ({
                ...prevParams,
                ACTION_STRING: newActionString.join(',')
            }));
        }
        else {
            newActionString[index] = value;
            setParams(prevParams => ({
                ...prevParams,
                ACTION_STRING: newActionString.join(',')
            }));
        }
    };

    const ACTION_STRING_OPTIONS = {
        e: [
            { label: 'Silence', value: '0' },
            { label: 'Normal Action', value: '1' }
        ],
        y: [
            { label: "Silence", value: '0' },
            { label: 'Idea', value: '1' },
            { label: 'Character', value: '2' }
        ],
        z: {
            idea: [
                { label: "Silence", value: '0' },
                { label: 'Support', value: '1' },
                { label: 'Neutral', value: '2' },
                { label: 'Negative', value: '3' },
                { label: 'Silence', value: '4' },
                { label: 'Conclude', value: '5' },
                { label: 'Dismiss', value: '6' }
            ],
            character: [
                { label: "Silence", value: '0' },
                { label: 'Support', value: '1' },
                { label: 'Neutral', value: '2' },
                { label: 'Negative', value: '3' },
                { label: 'Silence', value: '4' }
            ]
        }
    };

    let ideaAndCharacterIDs = [{ label: "Silence", value: '0' }];

    try {
        const state = lastState;

        //@ts-ignore
        const ideasKeys = Object.keys(state.ideas);

        for (let i = 0; i < ideasKeys.length; i++) {
            //@ts-ignore
            ideaAndCharacterIDs.push({ label: state.ideas[ideasKeys[i]].name, value: state.ideas[ideasKeys[i]].id });
        }

        //@ts-ignore
        const characterKeys = Object.keys(state.characters);

        for (let i = 0; i < characterKeys.length; i++) {
            //@ts-ignore
            ideaAndCharacterIDs.push({ label: state.characters[characterKeys[i]].name, value: state.characters[characterKeys[i]].id });
        }
    }
    catch (e) {

    }


    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {isRunning ? <span style={{ width: '50px' }}></span> : <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: '10px', marginBottom: '10px' }}>
                <Button intent={Intent.PRIMARY} disabled={!hasStartedGame} onClick={() => {
                    handleNextClick("scenario_1");
                }}>
                    Next Round (Silence)
                </Button>
                <Button intent={Intent.PRIMARY} disabled={hasStartedGame} onClick={() => {
                    handleClick("scenario_1");
                }}>
                    Start Game
                </Button>
            </div>}
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                backgroundColor: 'rgba(0,0,0,0.3)',
                padding: '10px'
            }}>
                {Object.keys(params).map(key => (
                    <div key={key} style={{ marginBottom: '10px' }}>
                        <FormGroup
                            label={key}
                            labelFor={key}
                            labelInfo="(required)"
                        >
                            {key === 'ACTION_STRING' ? (
                                <div>
                                    <Button
                                        id={key}
                                        intent={Intent.SUCCESS}
                                        name={key}
                                        //@ts-ignore
                                        onClick={() => {
                                            handleSelectChange(0, "1");
                                            setShowingActions(true);
                                        }}
                                        style={{ width: "100%" }}
                                        disabled={!hasStartedGame}
                                    >
                                        Make Action
                                    </Button>
                                    <Dialog isOpen={showingActions} onClose={() => {
                                        setShowingActions(false);
                                    }}>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <FormGroup label="Action String" labelFor="action-string">
                                                <HTMLSelect
                                                    id="e"
                                                    value={actionString[0]}
                                                    options={ACTION_STRING_OPTIONS.e}
                                                    onChange={(e) => handleSelectChange(0, e.target.value)}
                                                />
                                                <HTMLSelect
                                                    id="x"
                                                    value={actionString[1]}
                                                    options={ideaAndCharacterIDs}
                                                    onChange={(e) => handleSelectChange(1, e.target.value)}
                                                />
                                                <HTMLSelect
                                                    id="y"
                                                    value={actionString[2]}
                                                    options={ACTION_STRING_OPTIONS.y}
                                                    onChange={(e) => handleSelectChange(2, e.target.value)}
                                                />
                                                <HTMLSelect
                                                    id="z"
                                                    value={actionString[3]}
                                                    options={actionString[2] === '1' ? ACTION_STRING_OPTIONS.z.idea : ACTION_STRING_OPTIONS.z.character}
                                                    onChange={(e) => handleSelectChange(3, e.target.value)}
                                                />
                                            </FormGroup>
                                            <Button
                                                id={key}
                                                intent={Intent.SUCCESS}
                                                name={key}
                                                //@ts-ignore
                                                onClick={() => {
                                                    setShowingActions(false);
                                                    handleNextClick(params.SCENARIO_NAME);
                                                }}
                                                style={{ width: "100%" }}
                                                disabled={!hasStartedGame}
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </Dialog>
                                </div>
                            ) : (
                                <InputGroup
                                    id={key}
                                    name={key}
                                    type="text"
                                    value={params[key as keyof typeof params]}
                                    onChange={handleInputChange}
                                />
                            )}
                        </FormGroup>
                    </div>
                ))}
            </div>
            {renderOutput()}
        </div>
    );
}
